import App from './App.vue';

export default {
  path: '/CDS_VF_WelfareShelterDetail',
  name: 'CDS_VF_WelfareShelterDetail',
  component: App,
  meta: {
    pageProperty: {
      title: '福祉避難所詳細',
      controller: 'CDS_CTR_WelfareShelterDetail',
    },
  },
};
